import produce from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.TMaintenanceState = {
    endDate: '',
    startDate: '',
    isLoading: true,
    webContentId: '',
    isSchedulerEnabled: false,
    isAutoDetectEnabled: false,
    isMaintenanceEnabled: false,
    isIntegrationScriptFailed: false
};

export const reducer = produce((draftState, action: Types.TMaintenanceAction): Types.TMaintenanceState | void => {
    switch (action.type) {
        case actionTypes.MAINTENANCE_MODE_DATA_UPDATE: {
            Object.assign(draftState, {
                isLoading: false,
                ...action.payload
            });

            break;
        }

        case actionTypes.MAINTENANCE_MODE_IS_LOADING_UPDATE: {
            draftState.isLoading = action.payload;

            break;
        }

        case actionTypes.MAINTENANCE_MODE_IS_INTEGRATION_SCRIPT_FAILED_UPDATE: {
            draftState.isIntegrationScriptFailed = action.payload;

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
